import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'styled-components'
import { transparentize } from 'polished'

import { themeColor } from '@elparking/components'

const elementClasses = {
    base: 'CardInput',
    invalid: 'CardInputInvalid',
}

const getElementStyles = (props) => ({
    base: {
        color: themeColor('gray')(props),
        fontFamily: 'geomanist',
        '::placeholder': {
            color: window.matchMedia('(min-width: 768px)').matches
                ? transparentize(0.75, themeColor('gray')(props))
                : 'transparent',
        },
    },
    invalid: {
        color: themeColor('gray')(props),
    },
})

const StyledElement = ({ cardElement: Element, theme, onFocus, onBlur, onChange, onReady }) => (
    <Element
      style={getElementStyles({ theme })}
      classes={elementClasses}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      onReady={onReady}
    />
)

StyledElement.propTypes = {
    theme: PropTypes.object,
    cardElement: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onReady: PropTypes.func,
}

export default withTheme(StyledElement)
